import { ref } from 'vue'
import { tryOnMounted } from '@vueuse/core'
import { getAgentLevelSetting } from '@/api/team'

export function useAgentLevel(immediate = true) {
  const agentLevelList = ref([])
  const quasiAgentList = ref([])
  const getList = () =>
    new Promise((resolve, reject) => {
      getAgentLevelSetting({})
        .then(res => {
          const resList = res.list
          agentLevelList.value = resList.map(d => ({ label: d.levelName, value: d.level }))
          quasiAgentList.value = resList.map(d => ({ label: d.prepareLevelName, value: d.level }))
          resolve(true)
        })
        .catch(() => {
          reject(false)
        })
    })
  tryOnMounted(() => {
    immediate && getList()
  })
  return { agentLevelList, quasiAgentList, getLevelList: getList }
}
